import type { SceneCharacterFigure } from "@/lib/location-scene-3d/character-figure"
import { CHARACTER_FIGURES } from "@/lib/location-scene-3d/character-figures"
import { cn } from "@/lib/utils"

type HeroFigurePickerProps = {
  value: SceneCharacterFigure
  labelFor: (figure: SceneCharacterFigure) => string
  onPick: (figure: SceneCharacterFigure) => void
}

export function HeroFigurePicker({ value, labelFor, onPick }: HeroFigurePickerProps) {
  return (
    <div className="flex w-max flex-col gap-0.5 rounded-lg border border-ui-border bg-ui-surface p-0.5 shadow-md">
      {CHARACTER_FIGURES.map((item) => {
        const Icon = item.icon
        const active = item.id === value
        const label = labelFor(item.id)
        return (
          <button
            key={item.id}
            type="button"
            aria-label={label}
            aria-pressed={active}
            className={cn(
              "flex h-8 items-center gap-2 rounded-md px-2 text-left text-sm whitespace-nowrap text-ui-text-secondary",
              "hover:bg-ui-surface-raised hover:text-ui-text-primary",
              active && "bg-ui-surface-raised text-ui-text-primary",
            )}
            onClick={() => onPick(item.id)}
          >
            {item.mark ? (
              <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center text-xs font-medium">
                {item.mark}
              </span>
            ) : Icon ? (
              <Icon className="h-4 w-4 shrink-0" />
            ) : null}
            <span>{label}</span>
          </button>
        )
      })}
    </div>
  )
}
